import { elementsToMaxHeight } from '../utilities/elements-to-max-height'

$(window).on('load', function (e){
  if($(window).width() >= 800) {
    elementsToMaxHeight($('.apply-card-course-length'))
    elementsToMaxHeight($('.apply-card-course-price'))
  }
})
